import { DocumentPersonType, PersonType } from '@dealstack/shared/lib/generated';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

export const personPillMap = (type: DocumentPersonType) => {
	switch (type) {
		case DocumentPersonType.BUYER:
			return 'buyer';
		case DocumentPersonType.SELLER:
			return 'seller';
		case DocumentPersonType.ISSUER:
			return 'issuer';
		case DocumentPersonType.LINK:
			return 'link';
		default:
			return null;
	}
};

export const personIconMap = (type: PersonType): PredefinedIcons | undefined => {
	switch (type) {
		case PersonType.LEGAL:
			return 'building-office-company-entity-line';
		case PersonType.NATURAL:
			return 'user-profile';
		default:
			return undefined;
	}
};
